import { useCallback, useEffect, useState } from 'react';
import {
  clearStoredAccessKey,
  fetchFluxReferenceTransferBuildInfo,
  getStoredAccessKey,
  verifyFluxReferenceTransferAccess,
} from '../utils/fluxReferenceTransferApi';
import '../../flux-prompt-sample/components/FluxPromptSampleAccessGate.css';

export default function FluxReferenceTransferAccessGate({ children }) {
  const [ready, setReady] = useState(false);
  const [key, setKey] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [rev, setRev] = useState('');
  const [configured, setConfigured] = useState(true);

  useEffect(() => {
    fetchFluxReferenceTransferBuildInfo()
      .then((d) => {
        setRev(d?.rev || '');
        setConfigured(d?.access_configured !== false);
      })
      .catch(() => {});
    if (getStoredAccessKey()) setReady(true);
  }, []);

  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      setBusy(true);
      setError('');
      try {
        await verifyFluxReferenceTransferAccess(key.trim());
        setReady(true);
      } catch (err) {
        setError(err.message || 'Access denied');
        clearStoredAccessKey();
      } finally {
        setBusy(false);
      }
    },
    [key],
  );

  if (ready) return children;

  return (
    <div className="fps-gate">
      <div className="fps-gate-card">
        <h1>FLUX reference transfer</h1>
        <p className="fps-gate-lead">
          Dual-image i2i lab: guest photo keeps face and identity; reference photo donates styling only (not a face
          swap).
        </p>
        {!configured ? (
          <p className="fps-gate-warn" role="alert">
            Server: set <code>FLUX_PROMPT_SAMPLE_API_KEY</code> in backend <code>.env</code>.
          </p>
        ) : null}
        <form onSubmit={onSubmit}>
          <label className="fps-gate-label" htmlFor="frt-access-key">Access key</label>
          <input
            id="frt-access-key"
            type="password"
            className="fps-gate-input"
            autoComplete="off"
            value={key}
            onChange={(e) => setKey(e.target.value)}
            placeholder="Enter lab access key"
          />
          <button type="submit" className="fps-gate-btn" disabled={busy || !key.trim()}>
            {busy ? 'Checking…' : 'Continue'}
          </button>
        </form>
        {error ? <p className="fps-gate-error" role="alert">{error}</p> : null}
        {rev ? <p className="fps-gate-rev">rev {rev}</p> : null}
      </div>
    </div>
  );
}
